import React from 'react'

function WarningIcon({ width, height }: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 39.999 35">
      <path
        fill="#ffba08"
        d="M19.555-2.422L2.891-30.859a3.365 3.365 0 00-5.78 0L-19.545-2.422A3.281 3.281 0 00-16.661 2.5h33.328a3.287 3.287 0 002.888-4.922zm-21.43-19.453A1.875 1.875 0 010-23.75a1.878 1.878 0 011.875 1.875v10A1.862 1.862 0 01.07-10a1.982 1.982 0 01-1.945-1.875zM0-2.5a2.457 2.457 0 01-2.456-2.456A2.456 2.456 0 010-7.413a2.456 2.456 0 012.456 2.457A2.458 2.458 0 010-2.5z"
        data-name="Path 1951"
        transform="translate(19.997 32.5)"></path>
    </svg>
  )
}

export default WarningIcon
